import Button from '@components/base/button.component.tsx';
import CardActions from '@components/base/card/card-actions.component.tsx';
import CardContent from '@components/base/card/card-content.component.tsx';
import CardHeader from '@components/base/card/card-header.component.tsx';
import Card from '@components/base/card/card.component.tsx';
import { CircularLoaderContainer } from '@components/base/circular-loader-container.component.tsx';
import { theme } from '@/config/theme.ts';
import { DeleteForever, ShoppingCart } from '@mui/icons-material';
import { List, Typography } from '@mui/material';
import { useMemo } from 'react';
import { EmptyShoppingCart } from './overview/empty-cart.component.tsx';
import { CartItemListItem } from '@/modules/external/components/customer/cart/cart-item-list-item.component.tsx';
import { useCart, useUpsertCartItem } from '@/api/carts/carts.hooks.ts';
import { ClearCartButton } from '@components/clear-cart-button.component';
import { useTranslation } from 'react-i18next';

export function CartItemsCard() {
  const { t } = useTranslation('cart');
  const { data: cartData, isLoading } = useCart();
  const cartItems = useMemo(() => cartData?.cartItems || [], [cartData]);
  const { mutateAsync: upsertCartItem } = useUpsertCartItem();

  const handleRemoveItem = async () => {
    await upsertCartItem({
      cartItems: cartItems.map((item) => ({
        ...item,
        quantity: 0,
      })),
    });
  };

  return (
    <Card sx={{ width: '100%' }} elevation={2}>
      <CardHeader
        icon={<ShoppingCart />}
        title={
          <>
            <Typography
              variant={'h5'}
              color={theme.palette.primary.main}
              sx={{ pr: 1 }}
            >
              {t('title')}
            </Typography>
          </>
        }
      />
      {isLoading ? (
        <CircularLoaderContainer />
      ) : (
        <>
          {cartItems.length === 0 ? (
            <CardContent>
              <EmptyShoppingCart />
            </CardContent>
          ) : (
            <List
              sx={{
                width: '100%',
                ['li:nth-of-type(even)']: {
                  backgroundColor: 'rgba(0, 0, 0, 0.02)',
                },
              }}
            >
              {[...cartItems]
                .sort((a, b) => {
                  // sort alphabetically by item code and return
                  return a.item.id.localeCompare(b.item.id);
                })
                .map((cartItem) => (
                  <CartItemListItem key={cartItem.itemId} cartItem={cartItem} />
                ))}
            </List>
          )}
        </>
      )}
      <CardActions divider={false}>
        <ClearCartButton />
      </CardActions>
    </Card>
  );
}
